import { GetItemRequestTrackingDetailsState } from './getItemRequestTrackingDetails.types'

const initialState: GetItemRequestTrackingDetailsState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
